import { inject } from 'vue'

/**
 * This mixin holds common signage screens component code for signage screen and showings setting
 * data and determining setting for marginVertical, marginHorizontal, deBug, showLogo, highlightRRated, disableOfficialSymbol.
 *
 */
export default {
  props: {
    overrideMarginVertical: {
      type: Number,
      required: false,
      default: 0
    },
    overrideMarginHorizontal: {
      type: Number,
      required: false,
      default: 0
    },
    overrideDebug: {
      type: Boolean,
      required: false,
      default: false
    },
    showLogo: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['show-logo'] === 'true'
      }
    },
    highlightRRated: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['highlight-r-rated'] === 'true'
      }
    },
    disableOfficialSymbol: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['disable-official-symbol'] === 'true'
      }
    }
  },
  computed: {
    marginVertical () {
      return this.overrideMarginVertical || this.$route.query['margin-vertical'] || 0
    },
    marginHorizontal () {
      return this.overrideMarginHorizontal || this.$route.query['margin-horizontal'] || 0
    },
    debug () {
      return this.overrideDebug || this.$route.query.debug || false
    }
  }
}
